// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IPropertiesViewDto } from './IPropertiesViewDto';
import {
    IPropertiesViewDtoFromJSON,
    IPropertiesViewDtoFromJSONTyped,
    IPropertiesViewDtoToJSON,
    IPropertiesViewDtoToJSONTyped,
} from './IPropertiesViewDto';
import type { IMobileAppThemeDto } from './IMobileAppThemeDto';
import {
    IMobileAppThemeDtoFromJSON,
    IMobileAppThemeDtoFromJSONTyped,
    IMobileAppThemeDtoToJSON,
    IMobileAppThemeDtoToJSONTyped,
} from './IMobileAppThemeDto';
import type { IPaymentMethodConfigDto } from './IPaymentMethodConfigDto';
import {
    IPaymentMethodConfigDtoFromJSON,
    IPaymentMethodConfigDtoFromJSONTyped,
    IPaymentMethodConfigDtoToJSON,
    IPaymentMethodConfigDtoToJSONTyped,
} from './IPaymentMethodConfigDto';

/**
 * 
 * @export
 * @interface IOrganizationViewDto
 */
export interface IOrganizationViewDto {
    /**
     * 
     * @type {number}
     * @memberof IOrganizationViewDto
     */
    organization_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IOrganizationViewDto
     */
    organization_path?: string;
    /**
     * 
     * @type {string}
     * @memberof IOrganizationViewDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IOrganizationViewDto
     */
    partner_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IOrganizationViewDto
     */
    organization_type?: IOrganizationViewDtoOrganizationTypeEnum;
    /**
     * 
     * @type {IPropertiesViewDto}
     * @memberof IOrganizationViewDto
     */
    properties_view?: IPropertiesViewDto;
    /**
     * 
     * @type {IMobileAppThemeDto}
     * @memberof IOrganizationViewDto
     */
    mobile_app_theme?: IMobileAppThemeDto;
    /**
     * 
     * @type {Date}
     * @memberof IOrganizationViewDto
     */
    termination_date?: Date;
    /**
     * 
     * @type {string}
     * @memberof IOrganizationViewDto
     */
    current_org_status?: IOrganizationViewDtoCurrentOrgStatusEnum;
    /**
     * 
     * @type {Array<IPaymentMethodConfigDto>}
     * @memberof IOrganizationViewDto
     */
    allowed_payment_method_configs?: Array<IPaymentMethodConfigDto>;
    /**
     * 
     * @type {boolean}
     * @memberof IOrganizationViewDto
     */
    is_limited_features_during_termination_in_progress?: boolean;
}

/**
* @export
* @enum {string}
*/
export enum IOrganizationViewDtoOrganizationTypeEnum {
    SYSTEM = 'SYSTEM',
    PARTNER = 'PARTNER',
    DISTRIBUTOR = 'DISTRIBUTOR',
    COMPANY = 'COMPANY',
    SUBSIDIARY = 'SUBSIDIARY',
    SUBGROUP = 'SUBGROUP'
}
/**
* @export
* @enum {string}
*/
export enum IOrganizationViewDtoCurrentOrgStatusEnum {
    PENDING = 'PENDING',
    ACTIVE = 'ACTIVE',
    TERMINATED = 'TERMINATED',
    ACTIVATION_FAILED = 'ACTIVATION_FAILED',
    PENDING_TERMINATION = 'PENDING_TERMINATION',
    EXPRESS_SETUP = 'EXPRESS_SETUP',
    ABANDONED = 'ABANDONED',
    TERMINATION_IN_PROGRESS = 'TERMINATION_IN_PROGRESS',
    PENDING_REACTIVATION = 'PENDING_REACTIVATION'
}


/**
 * Check if a given object implements the IOrganizationViewDto interface.
 */
export function instanceOfIOrganizationViewDto(value: object): value is IOrganizationViewDto {
    return true;
}

export function IOrganizationViewDtoFromJSON(json: any): IOrganizationViewDto {
    return IOrganizationViewDtoFromJSONTyped(json, false);
}

export function IOrganizationViewDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IOrganizationViewDto {
    if (json == null) {
        return json;
    }
    return {
        
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'organization_path': json['organization_path'] == null ? undefined : json['organization_path'],
        'name': json['name'] == null ? undefined : json['name'],
        'partner_name': json['partner_name'] == null ? undefined : json['partner_name'],
        'organization_type': json['organization_type'] == null ? undefined : json['organization_type'],
        'properties_view': json['properties_view'] == null ? undefined : IPropertiesViewDtoFromJSON(json['properties_view']),
        'mobile_app_theme': json['mobile_app_theme'] == null ? undefined : IMobileAppThemeDtoFromJSON(json['mobile_app_theme']),
        'termination_date': json['termination_date'] == null ? undefined : (new Date(json['termination_date'])),
        'current_org_status': json['current_org_status'] == null ? undefined : json['current_org_status'],
        'allowed_payment_method_configs': json['allowed_payment_method_configs'] == null ? undefined : ((json['allowed_payment_method_configs'] as Array<any>).map(IPaymentMethodConfigDtoFromJSON)),
        'is_limited_features_during_termination_in_progress': json['is_limited_features_during_termination_in_progress'] == null ? undefined : json['is_limited_features_during_termination_in_progress'],
    };
}

export function IOrganizationViewDtoToJSON(json: any): IOrganizationViewDto {
    return IOrganizationViewDtoToJSONTyped(json, false);
}

export function IOrganizationViewDtoToJSONTyped(value?: IOrganizationViewDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'organization_id': value['organization_id'],
        'organization_path': value['organization_path'],
        'name': value['name'],
        'partner_name': value['partner_name'],
        'organization_type': value['organization_type'],
        'properties_view': IPropertiesViewDtoToJSON(value['properties_view']),
        'mobile_app_theme': IMobileAppThemeDtoToJSON(value['mobile_app_theme']),
        'termination_date': value['termination_date'] == null ? undefined : ((value['termination_date']).toISOString()),
        'current_org_status': value['current_org_status'],
        'allowed_payment_method_configs': value['allowed_payment_method_configs'] == null ? undefined : ((value['allowed_payment_method_configs'] as Array<any>).map(IPaymentMethodConfigDtoToJSON)),
        'is_limited_features_during_termination_in_progress': value['is_limited_features_during_termination_in_progress'],
    };
}

